import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderBillingV2ClaimCases: build.query<
      GetV2ProviderBillingV2ClaimCasesApiResponse,
      GetV2ProviderBillingV2ClaimCasesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-cases`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          segment: queryArg.segment,
        },
      }),
    }),
    getV2ProviderBillingV2ClaimCasesByClaimId: build.query<
      GetV2ProviderBillingV2ClaimCasesByClaimIdApiResponse,
      GetV2ProviderBillingV2ClaimCasesByClaimIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-cases/${queryArg.claimId}`,
      }),
    }),
    postV2ProviderBillingV2ClaimCasesByClaimIdReview: build.mutation<
      PostV2ProviderBillingV2ClaimCasesByClaimIdReviewApiResponse,
      PostV2ProviderBillingV2ClaimCasesByClaimIdReviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-cases/${queryArg.claimId}/review`,
        method: "POST",
        params: {
          force: queryArg.force,
        },
      }),
    }),
    getV2ProviderBillingV2ClaimWork: build.query<
      GetV2ProviderBillingV2ClaimWorkApiResponse,
      GetV2ProviderBillingV2ClaimWorkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-work`,
        params: {
          work_view: queryArg.workView,
          provider_ids: queryArg.providerIds,
          payer_ids: queryArg.payerIds,
          patient_ids: queryArg.patientIds,
          claim_lifecycles: queryArg.claimLifecycles,
          service_date_window_days: queryArg.serviceDateWindowDays,
          service_date_from: queryArg.serviceDateFrom,
          service_date_to: queryArg.serviceDateTo,
          sort: queryArg.sort,
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          include_hidden: queryArg.includeHidden,
        },
      }),
    }),
    getV2ProviderBillingV2ClaimWorkSavedViews: build.query<
      GetV2ProviderBillingV2ClaimWorkSavedViewsApiResponse,
      GetV2ProviderBillingV2ClaimWorkSavedViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-work/saved-views`,
        params: {
          include_hidden: queryArg.includeHidden,
        },
      }),
    }),
    postV2ProviderBillingV2ClaimWorkSavedViews: build.mutation<
      PostV2ProviderBillingV2ClaimWorkSavedViewsApiResponse,
      PostV2ProviderBillingV2ClaimWorkSavedViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-work/saved-views`,
        method: "POST",
        body: queryArg.createBillingSavedViewRequest,
      }),
    }),
    deleteV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewId: build.mutation<
      DeleteV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiResponse,
      DeleteV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-work/saved-views/${queryArg.savedViewId}`,
        method: "DELETE",
        params: {
          expected_version: queryArg.expectedVersion,
        },
      }),
    }),
    putV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewId: build.mutation<
      PutV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiResponse,
      PutV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claim-work/saved-views/${queryArg.savedViewId}`,
        method: "PUT",
        body: queryArg.updateBillingSavedViewRequest,
      }),
    }),
    getV2ProviderBillingV2Claims: build.query<
      GetV2ProviderBillingV2ClaimsApiResponse,
      GetV2ProviderBillingV2ClaimsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claims`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          phase: queryArg.phase,
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          include_superseded: queryArg.includeSuperseded,
        },
      }),
    }),
    getV2ProviderBillingV2ClaimsByClaimIdPaidResolution: build.query<
      GetV2ProviderBillingV2ClaimsByClaimIdPaidResolutionApiResponse,
      GetV2ProviderBillingV2ClaimsByClaimIdPaidResolutionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claims/${queryArg.claimId}/paid-resolution`,
      }),
    }),
    postV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopen: build.mutation<
      PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopenApiResponse,
      PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claims/${queryArg.claimId}/paid-resolution/reopen`,
        method: "POST",
        body: queryArg.paidClaimResolutionReopenRequest,
      }),
    }),
    postV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolve: build.mutation<
      PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolveApiResponse,
      PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/claims/${queryArg.claimId}/paid-resolution/resolve`,
        method: "POST",
        body: queryArg.paidClaimResolutionRequest,
      }),
    }),
    postV2ProviderBillingV2EncountersByEncounterIdWorkDisposition:
      build.mutation<
        PostV2ProviderBillingV2EncountersByEncounterIdWorkDispositionApiResponse,
        PostV2ProviderBillingV2EncountersByEncounterIdWorkDispositionApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing/v2/encounters/${queryArg.encounterId}/work-disposition`,
          method: "POST",
          body: queryArg.encounterWorkDispositionRequest,
        }),
      }),
    getV2ProviderBillingV2EncountersByEncounterIdWorkNotes: build.query<
      GetV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiResponse,
      GetV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/encounters/${queryArg.encounterId}/work-notes`,
      }),
    }),
    postV2ProviderBillingV2EncountersByEncounterIdWorkNotes: build.mutation<
      PostV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiResponse,
      PostV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/encounters/${queryArg.encounterId}/work-notes`,
        method: "POST",
        body: queryArg.encounterWorkNoteRequest,
      }),
    }),
    deleteV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteId:
      build.mutation<
        DeleteV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiResponse,
        DeleteV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing/v2/encounters/${queryArg.encounterId}/work-notes/${queryArg.noteId}`,
          method: "DELETE",
        }),
      }),
    patchV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteId:
      build.mutation<
        PatchV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiResponse,
        PatchV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing/v2/encounters/${queryArg.encounterId}/work-notes/${queryArg.noteId}`,
          method: "PATCH",
          body: queryArg.encounterWorkNoteEditRequest,
        }),
      }),
    getV2ProviderBillingV2Overview: build.query<
      GetV2ProviderBillingV2OverviewApiResponse,
      GetV2ProviderBillingV2OverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/overview`,
        params: {
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
        },
      }),
    }),
    getV2ProviderBillingV2PatientBillingQueue: build.query<
      GetV2ProviderBillingV2PatientBillingQueueApiResponse,
      GetV2ProviderBillingV2PatientBillingQueueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patient-billing/queue`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          patient_id: queryArg.patientId,
        },
      }),
    }),
    getV2ProviderBillingV2PatientBillingSent: build.query<
      GetV2ProviderBillingV2PatientBillingSentApiResponse,
      GetV2ProviderBillingV2PatientBillingSentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patient-billing/sent`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          status: queryArg.status,
          patient_id: queryArg.patientId,
        },
      }),
    }),
    getV2ProviderBillingV2PatientsByPatientIdAccountHistory: build.query<
      GetV2ProviderBillingV2PatientsByPatientIdAccountHistoryApiResponse,
      GetV2ProviderBillingV2PatientsByPatientIdAccountHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patients/${queryArg.patientId}/account-history`,
        params: {
          from_date: queryArg.fromDate,
          to_date: queryArg.toDate,
        },
      }),
    }),
    postV2ProviderBillingV2PatientsByPatientIdChargeAssignments: build.mutation<
      PostV2ProviderBillingV2PatientsByPatientIdChargeAssignmentsApiResponse,
      PostV2ProviderBillingV2PatientsByPatientIdChargeAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patients/${queryArg.patientId}/charge-assignments`,
        method: "POST",
        body: queryArg.assignChargeToEncounterRequest,
      }),
    }),
    postV2ProviderBillingV2PatientsByPatientIdCreditAllocations: build.mutation<
      PostV2ProviderBillingV2PatientsByPatientIdCreditAllocationsApiResponse,
      PostV2ProviderBillingV2PatientsByPatientIdCreditAllocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patients/${queryArg.patientId}/credit-allocations`,
        method: "POST",
        body: queryArg.creditAllocationRequest,
      }),
    }),
    getV2ProviderBillingV2PatientsByPatientIdFinancialSummary: build.query<
      GetV2ProviderBillingV2PatientsByPatientIdFinancialSummaryApiResponse,
      GetV2ProviderBillingV2PatientsByPatientIdFinancialSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patients/${queryArg.patientId}/financial-summary`,
      }),
    }),
    getV2ProviderBillingV2PatientsByPatientIdRefundablePayments: build.query<
      GetV2ProviderBillingV2PatientsByPatientIdRefundablePaymentsApiResponse,
      GetV2ProviderBillingV2PatientsByPatientIdRefundablePaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patients/${queryArg.patientId}/refundable-payments`,
        params: {
          source_encounter_id: queryArg.sourceEncounterId,
        },
      }),
    }),
    postV2ProviderBillingV2PatientsByPatientIdRefunds: build.mutation<
      PostV2ProviderBillingV2PatientsByPatientIdRefundsApiResponse,
      PostV2ProviderBillingV2PatientsByPatientIdRefundsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/patients/${queryArg.patientId}/refunds`,
        method: "POST",
        body: queryArg.patientRefundRequest,
      }),
    }),
    getV2ProviderBillingV2PayerOptions: build.query<
      GetV2ProviderBillingV2PayerOptionsApiResponse,
      GetV2ProviderBillingV2PayerOptionsApiArg
    >({
      query: () => ({ url: `/v2/provider/billing/v2/payer-options` }),
    }),
    getV2ProviderBillingV2Remittances: build.query<
      GetV2ProviderBillingV2RemittancesApiResponse,
      GetV2ProviderBillingV2RemittancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/remittances`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          outcome: queryArg.outcome,
          payer_name: queryArg.payerName,
          payment_method: queryArg.paymentMethod,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2ProviderBillingV2Tasks: build.query<
      GetV2ProviderBillingV2TasksApiResponse,
      GetV2ProviderBillingV2TasksApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/tasks`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          status: queryArg.status,
          category: queryArg.category,
          subject_type: queryArg.subjectType,
          subject_id: queryArg.subjectId,
        },
      }),
    }),
    postV2ProviderBillingV2Tasks: build.mutation<
      PostV2ProviderBillingV2TasksApiResponse,
      PostV2ProviderBillingV2TasksApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/tasks`,
        method: "POST",
        body: queryArg.createBillingTaskRequest,
      }),
    }),
    patchV2ProviderBillingV2TasksByBillingTaskIdStatus: build.mutation<
      PatchV2ProviderBillingV2TasksByBillingTaskIdStatusApiResponse,
      PatchV2ProviderBillingV2TasksByBillingTaskIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/tasks/${queryArg.billingTaskId}/status`,
        method: "PATCH",
        body: queryArg.updateBillingTaskStatusRequest,
      }),
    }),
    getV2ProviderBillingV2Work: build.query<
      GetV2ProviderBillingV2WorkApiResponse,
      GetV2ProviderBillingV2WorkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/v2/work`,
        params: {
          segment: queryArg.segment,
        },
      }),
    }),
    postV2ProviderChargeLinesPreview: build.mutation<
      PostV2ProviderChargeLinesPreviewApiResponse,
      PostV2ProviderChargeLinesPreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/charge-lines/preview`,
        method: "POST",
        body: queryArg.chargeLinePreviewRequest,
      }),
    }),
    getV2ProviderClaimsByClaimIdCertification: build.query<
      GetV2ProviderClaimsByClaimIdCertificationApiResponse,
      GetV2ProviderClaimsByClaimIdCertificationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/certification`,
      }),
    }),
    postV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyDismiss:
      build.mutation<
        PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyDismissApiResponse,
        PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyDismissApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/claims/${queryArg.claimId}/certification/findings/${queryArg.findingKey}/dismiss`,
          method: "POST",
          body: queryArg.dispositionCommandRequest,
        }),
      }),
    postV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyReopen:
      build.mutation<
        PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyReopenApiResponse,
        PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyReopenApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/claims/${queryArg.claimId}/certification/findings/${queryArg.findingKey}/reopen`,
          method: "POST",
          body: queryArg.dispositionCommandRequest,
        }),
      }),
    postV2ProviderClaimsByClaimIdCertificationRecheck: build.mutation<
      PostV2ProviderClaimsByClaimIdCertificationRecheckApiResponse,
      PostV2ProviderClaimsByClaimIdCertificationRecheckApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/certification/recheck`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderBillingV2ClaimCasesApiResponse =
  /** status 200 OK */ ClaimCaseListResponse;
export type GetV2ProviderBillingV2ClaimCasesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Problem claim segment to show */
  segment?:
    | "all"
    | "rejected"
    | "denied"
    | "partial"
    | "patientResponsibility"
    | "secondary"
    | "reversal"
    | "unmatched"
    | "manualReview";
};
export type GetV2ProviderBillingV2ClaimCasesByClaimIdApiResponse =
  /** status 200 OK */ ClaimCaseDetailResponse;
export type GetV2ProviderBillingV2ClaimCasesByClaimIdApiArg = {
  claimId: string;
};
export type PostV2ProviderBillingV2ClaimCasesByClaimIdReviewApiResponse =
  /** status 200 OK */
    | GenerateClaimCaseReviewResponse
    | /** status 202 Accepted */ GenerateClaimCaseReviewResponse;
export type PostV2ProviderBillingV2ClaimCasesByClaimIdReviewApiArg = {
  claimId: string;
  /** Create a fresh manual review trigger even if a review exists */
  force?: boolean;
};
export type GetV2ProviderBillingV2ClaimWorkApiResponse =
  /** status 200 OK */ ClaimWorkListResponse;
export type GetV2ProviderBillingV2ClaimWorkApiArg = {
  workView?: ClaimWorkViewKey;
  /** Comma-separated provider IDs */
  providerIds?: string | null;
  /** Comma-separated payer UUIDs */
  payerIds?: string | null;
  /** Comma-separated patient UUIDs */
  patientIds?: string | null;
  /** Comma-separated exact claim lifecycle codes */
  claimLifecycles?: string | null;
  /** Rolling service-date window ending today, inclusive */
  serviceDateWindowDays?: number | null;
  serviceDateFrom?: string | null;
  serviceDateTo?: string | null;
  sort?: ClaimWorkSortKey;
  limit?: number;
  cursor?: string | null;
  /** Show rows an encounter work disposition hides. Queues only; the lists never hide a row */
  includeHidden?: boolean;
};
export type GetV2ProviderBillingV2ClaimWorkSavedViewsApiResponse =
  /** status 200 OK */ BillingSavedViewListResponse;
export type GetV2ProviderBillingV2ClaimWorkSavedViewsApiArg = {
  /** Count rows an encounter work disposition hides, matching the claim-work page's flag */
  includeHidden?: boolean;
};
export type PostV2ProviderBillingV2ClaimWorkSavedViewsApiResponse =
  /** status 200 OK */ BillingSavedViewResponse;
export type PostV2ProviderBillingV2ClaimWorkSavedViewsApiArg = {
  createBillingSavedViewRequest: CreateBillingSavedViewRequest;
};
export type DeleteV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiResponse =
  /** status 200 OK */ DeleteBillingSavedViewResponse;
export type DeleteV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiArg = {
  savedViewId: string;
  expectedVersion: number;
};
export type PutV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiResponse =
  /** status 200 OK */ BillingSavedViewResponse;
export type PutV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdApiArg = {
  savedViewId: string;
  updateBillingSavedViewRequest: UpdateBillingSavedViewRequest;
};
export type GetV2ProviderBillingV2ClaimsApiResponse =
  /** status 200 OK */ ClaimsV2Response;
export type GetV2ProviderBillingV2ClaimsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by phase: drafts, ready, inFlight, paid, review, imported */
  phase?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs */
  providerIds?: string | null;
  /** Filter by payer UUID */
  payerUuid?: string | null;
  /** Service date from (ISO 8601) */
  dateFrom?: string | null;
  /** Service date to (ISO 8601) */
  dateTo?: string | null;
  /** Sort by: created_at, service_date_from, total_charge_cents */
  sortBy?: "created_at" | "service_date_from" | "total_charge_cents";
  /** Sort order: asc or desc */
  sortOrder?: "asc" | "desc";
  /** Include claims that have been superseded by a correction or void */
  includeSuperseded?: boolean;
};
export type GetV2ProviderBillingV2ClaimsByClaimIdPaidResolutionApiResponse =
  /** status 200 OK */ PaidClaimResolutionReviewResponse;
export type GetV2ProviderBillingV2ClaimsByClaimIdPaidResolutionApiArg = {
  claimId: string;
};
export type PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopenApiResponse =
  /** status 200 OK */ PaidClaimResolutionReviewResponse;
export type PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopenApiArg = {
  claimId: string;
  paidClaimResolutionReopenRequest: PaidClaimResolutionReopenRequest;
};
export type PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolveApiResponse =
  /** status 200 OK */ PaidClaimResolutionReviewResponse;
export type PostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolveApiArg =
  {
    claimId: string;
    paidClaimResolutionRequest: PaidClaimResolutionRequest;
  };
export type PostV2ProviderBillingV2EncountersByEncounterIdWorkDispositionApiResponse =
  /** status 200 OK */ EncounterWorkDispositionResponse;
export type PostV2ProviderBillingV2EncountersByEncounterIdWorkDispositionApiArg =
  {
    encounterId: string;
    encounterWorkDispositionRequest: EncounterWorkDispositionRequest;
  };
export type GetV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiResponse =
  /** status 200 OK */ EncounterWorkNotesResponse;
export type GetV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiArg = {
  encounterId: string;
};
export type PostV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiResponse =
  /** status 201 Created */ EncounterWorkNoteResponse;
export type PostV2ProviderBillingV2EncountersByEncounterIdWorkNotesApiArg = {
  encounterId: string;
  encounterWorkNoteRequest: EncounterWorkNoteRequest;
};
export type DeleteV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiResponse =
  unknown;
export type DeleteV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiArg =
  {
    encounterId: string;
    noteId: string;
  };
export type PatchV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiResponse =
  /** status 200 OK */ EncounterWorkNoteResponse;
export type PatchV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdApiArg =
  {
    encounterId: string;
    noteId: string;
    encounterWorkNoteEditRequest: EncounterWorkNoteEditRequest;
  };
export type GetV2ProviderBillingV2OverviewApiResponse =
  /** status 200 OK */ BillingOverviewResponse;
export type GetV2ProviderBillingV2OverviewApiArg = {
  /** Filter from date (ISO 8601). Defaults to 30 days ago. */
  dateFrom?: string | null;
  /** Filter to date (ISO 8601). Defaults to now. */
  dateTo?: string | null;
};
export type GetV2ProviderBillingV2PatientBillingQueueApiResponse =
  /** status 200 OK */ PatientBillingQueueResponse;
export type GetV2ProviderBillingV2PatientBillingQueueApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by patient ID */
  patientId?: string | null;
};
export type GetV2ProviderBillingV2PatientBillingSentApiResponse =
  /** status 200 OK */ SentInvoicesResponse;
export type GetV2ProviderBillingV2PatientBillingSentApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by status: paid, open, void, uncollectible */
  status?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
};
export type GetV2ProviderBillingV2PatientsByPatientIdAccountHistoryApiResponse =
  unknown;
export type GetV2ProviderBillingV2PatientsByPatientIdAccountHistoryApiArg = {
  patientId: string;
  /** Range start (ISO date); entries before it fold into the opening balance */
  fromDate?: string | null;
  /** Range end (ISO date), inclusive */
  toDate?: string | null;
};
export type PostV2ProviderBillingV2PatientsByPatientIdChargeAssignmentsApiResponse =
  /** status 201 Created */ AssignChargeToEncounterResponse;
export type PostV2ProviderBillingV2PatientsByPatientIdChargeAssignmentsApiArg =
  {
    patientId: string;
    assignChargeToEncounterRequest: AssignChargeToEncounterRequest;
  };
export type PostV2ProviderBillingV2PatientsByPatientIdCreditAllocationsApiResponse =
  /** status 201 Created */ CreditAllocationResponse;
export type PostV2ProviderBillingV2PatientsByPatientIdCreditAllocationsApiArg =
  {
    patientId: string;
    creditAllocationRequest: CreditAllocationRequest;
  };
export type GetV2ProviderBillingV2PatientsByPatientIdFinancialSummaryApiResponse =
  /** status 200 OK */ PatientFinancialSummaryResponse;
export type GetV2ProviderBillingV2PatientsByPatientIdFinancialSummaryApiArg = {
  patientId: string;
};
export type GetV2ProviderBillingV2PatientsByPatientIdRefundablePaymentsApiResponse =
  /** status 200 OK */ RefundablePaymentsResponse;
export type GetV2ProviderBillingV2PatientsByPatientIdRefundablePaymentsApiArg =
  {
    patientId: string;
    /** Encounter scope; omit for the account-level scope. */
    sourceEncounterId?: string | null;
  };
export type PostV2ProviderBillingV2PatientsByPatientIdRefundsApiResponse =
  /** status 201 Created */ PatientRefundResponse;
export type PostV2ProviderBillingV2PatientsByPatientIdRefundsApiArg = {
  patientId: string;
  patientRefundRequest: PatientRefundRequest;
};
export type GetV2ProviderBillingV2PayerOptionsApiResponse =
  /** status 200 OK */ BillingPayerOptionsResponse;
export type GetV2ProviderBillingV2PayerOptionsApiArg = void;
export type GetV2ProviderBillingV2RemittancesApiResponse =
  /** status 200 OK */ RemittancesV2Response;
export type GetV2ProviderBillingV2RemittancesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by outcome: all, denials, reversals, clean, imported */
  outcome?: string | null;
  /** Filter by payer name (partial match) */
  payerName?: string | null;
  /** Filter by payment method: ACH or Check */
  paymentMethod?: string | null;
  /** Payment date from (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Payment date to (YYYY-MM-DD) */
  dateTo?: string | null;
  /** Sort by column */
  sortBy?: "payment_date" | "total_payment_amount_cents" | "created_at";
  /** Sort order: asc or desc */
  sortOrder?: "asc" | "desc";
};
export type GetV2ProviderBillingV2TasksApiResponse =
  /** status 200 OK */ BillingTaskListResponse;
export type GetV2ProviderBillingV2TasksApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by task status */
  status?: BillingTaskStatus2 | null;
  /** Filter by task category */
  category?: BillingTaskCategory2 | null;
  /** Filter by subject type */
  subjectType?: BillingTaskSubjectType2 | null;
  /** Filter by subject id (claim or remittance claim) */
  subjectId?: string | null;
};
export type PostV2ProviderBillingV2TasksApiResponse =
  /** status 200 OK */ BillingTaskResponse;
export type PostV2ProviderBillingV2TasksApiArg = {
  createBillingTaskRequest: CreateBillingTaskRequest;
};
export type PatchV2ProviderBillingV2TasksByBillingTaskIdStatusApiResponse =
  /** status 200 OK */ BillingTaskResponse;
export type PatchV2ProviderBillingV2TasksByBillingTaskIdStatusApiArg = {
  billingTaskId: string;
  updateBillingTaskStatusRequest: UpdateBillingTaskStatusRequest;
};
export type GetV2ProviderBillingV2WorkApiResponse =
  /** status 200 OK */ WorkQueueResponse;
export type GetV2ProviderBillingV2WorkApiArg = {
  /** Filter by segment: all, denied, errors, ready, toSend */
  segment?: string | null;
};
export type PostV2ProviderChargeLinesPreviewApiResponse =
  /** status 200 OK */ ChargeLinePreviewResponse;
export type PostV2ProviderChargeLinesPreviewApiArg = {
  chargeLinePreviewRequest: ChargeLinePreviewRequest;
};
export type GetV2ProviderClaimsByClaimIdCertificationApiResponse =
  /** status 200 OK */ ClaimCertificationResponse;
export type GetV2ProviderClaimsByClaimIdCertificationApiArg = {
  claimId: string;
};
export type PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyDismissApiResponse =
  /** status 200 OK */ DispositionCommandResponse;
export type PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyDismissApiArg =
  {
    claimId: string;
    findingKey: string;
    dispositionCommandRequest: DispositionCommandRequest;
  };
export type PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyReopenApiResponse =
  /** status 200 OK */ DispositionCommandResponse;
export type PostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyReopenApiArg =
  {
    claimId: string;
    findingKey: string;
    dispositionCommandRequest: DispositionCommandRequest;
  };
export type PostV2ProviderClaimsByClaimIdCertificationRecheckApiResponse =
  /** status 200 OK */ ClaimCertificationResponse;
export type PostV2ProviderClaimsByClaimIdCertificationRecheckApiArg = {
  claimId: string;
};
export type ClaimReviewLane =
  | "rejected_before_payer"
  | "payer_rework"
  | "coding_review"
  | "clinician_documentation"
  | "eligibility_registration"
  | "authorization"
  | "credentialing_enrollment"
  | "patient_responsibility_review"
  | "secondary_billing"
  | "reversal_recoupment"
  | "matching_posting"
  | "manual_review";
export type ClaimOwnerRole =
  | "biller"
  | "coder"
  | "clinician"
  | "front_desk"
  | "credentialing"
  | "patient_billing"
  | "payment_poster"
  | "manager";
export type BillingCodeRef = {
  code: string;
  code_id: string;
  display: string;
  modifiers?: string[];
  system: string;
};
export type ClaimReviewPriority = "low" | "normal" | "high" | "urgent";
export type ClaimCaseListItem = {
  active_problem: boolean;
  amount_at_risk_cents?: number | null;
  brief: string;
  claim_case_id: string;
  claim_id: string;
  confidence_level?: string | null;
  date_of_service_end?: string | null;
  date_of_service_start: string;
  encounter_id?: string | null;
  lane?: ClaimReviewLane | null;
  latest_review_id?: string | null;
  owner_role?: ClaimOwnerRole | null;
  patient_display: string;
  payer_name: string;
  primary_billing_code?: BillingCodeRef | null;
  priority?: ClaimReviewPriority | null;
  provider_display: string;
  recommended_action_label?: string | null;
  root_cause_label?: string | null;
  service_type_label?: string | null;
  stage: string;
  stage_label: string;
};
export type SegmentCount = {
  /** Number of items in this segment */
  count: number;
  /** Segment key */
  key: string;
  /** Display label */
  label: string;
  /** Color hint: error, warning, success, or null */
  severity?: string | null;
};
export type ClaimCaseListResponse = {
  items?: ClaimCaseListItem[];
  page?: number;
  per_page?: number;
  segments?: SegmentCount[];
  summary: string;
  total?: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ClaimCaseFinancialSummary = {
  allowed_cents?: number | null;
  amount_at_risk_cents?: number | null;
  patient_responsibility_cents?: number | null;
  payer_paid_cents?: number | null;
  provider_adjustment_cents?: number | null;
  total_charged_cents?: number | null;
};
export type ClaimCaseLatestReview = {
  action_summary?: {
    [key: string]: any;
  } | null;
  claim_case_review_id: string;
  confidence_level?: string | null;
  explained_codes?: {
    [key: string]: any;
  }[];
  patient_billing_gate?: {
    [key: string]: any;
  } | null;
  primary_action_label?: string | null;
  primary_finding?: {
    [key: string]: any;
  } | null;
  priority?: string | null;
  problem_explanation?: {
    [key: string]: any;
  } | null;
  recommended_action?: {
    [key: string]: any;
  } | null;
  resolution_path_explanation?: string | null;
  root_cause_label?: string | null;
  stage_label?: string | null;
};
export type ClaimCaseLifecycleSummary = {
  active_problem: boolean;
  confidence?: string;
  stage: string;
  stage_label: string;
  stage_reason: string;
};
export type BillingCodeRef2 = {
  code: string;
  code_id: string;
  display: string;
  modifiers?: string[];
  system: string;
};
export type ClaimCaseProblemEvent = {
  affected_line_ids?: string[];
  affected_scope: string;
  category: string;
  event_id: string;
  event_kind: string;
  occurred_at: string;
  reason_codes?: {
    [key: string]: any;
  }[];
  summary?: string | null;
};
export type ClaimCaseTimelineItem = {
  event_id: string;
  event_kind: string;
  is_current: boolean;
  label: string;
  occurred_at: string;
  source_kind: string;
  source_ref_ids?: string[];
};
export type ClaimCase = {
  brief: string;
  claim_case_id: string;
  claim_id: string;
  date_of_service_end?: string | null;
  date_of_service_start: string;
  encounter_id?: string | null;
  financial_summary: ClaimCaseFinancialSummary;
  latest_review?: ClaimCaseLatestReview | null;
  lifecycle: ClaimCaseLifecycleSummary;
  organization_id: string;
  patient_display: string;
  payer_name: string;
  primary_billing_code?: BillingCodeRef2 | null;
  problem_events?: ClaimCaseProblemEvent[];
  provider_display: string;
  timeline?: ClaimCaseTimelineItem[];
};
export type ClaimActionKind =
  | "fix_and_resubmit"
  | "submit_corrected_claim"
  | "appeal"
  | "send_documentation"
  | "payer_inquiry"
  | "verify_eligibility"
  | "verify_authorization"
  | "verify_coverage"
  | "verify_provider_enrollment"
  | "bill_patient"
  | "send_to_secondary"
  | "wait_for_secondary"
  | "post_payment"
  | "post_write_off"
  | "review_reversal"
  | "match_remittance"
  | "manual_review"
  | "no_action";
export type SafetySeverity = "warning" | "hard_stop";
export type ClaimCaseReviewBlockedAction = {
  label: string;
  reason: string;
  severity: SafetySeverity;
};
export type ConfidenceLevel = "low" | "medium" | "high";
export type ClaimOwnerRole2 =
  | "biller"
  | "coder"
  | "clinician"
  | "front_desk"
  | "credentialing"
  | "patient_billing"
  | "payment_poster"
  | "manager";
export type ClaimCaseReviewActionSummary = {
  action_kind: ClaimActionKind;
  blocked_actions?: ClaimCaseReviewBlockedAction[];
  confidence_level: ConfidenceLevel;
  instruction: string;
  label: string;
  owner_role: ClaimOwnerRole2;
  rationale: string;
};
export type ClaimCaseClinicianRequest = {
  clinician_safe_summary: string;
  do_not_ask_clinician_to_change_coding: boolean;
  needed: boolean;
  requested_facts?: string[];
};
export type ClaimCaseConfidence = {
  level: ConfidenceLevel;
  limiting_factors?: string[];
  reason: string;
  score?: number | null;
};
export type ClaimCaseSafetyWarning = {
  label: string;
  reason: string;
  severity: SafetySeverity;
};
export type ClaimCaseEvidenceItem = {
  detail: string;
  evidence_ref_id: string;
  reference: string;
  source_id?: string | null;
  source_kind: string;
  supports: string;
};
export type ClaimCaseReviewExplainedCode = {
  code: string;
  code_system: string;
  code_system_label: string;
  definition?: string | null;
  display_code: string;
  evidence_ref_ids?: string[];
  explanation_source?:
    | "deterministic"
    | "stedi_value"
    | "llm_contextualized"
    | "unmapped";
  group_code?: string | null;
  medium_explanation: string;
  official_description?: string | null;
  plain_title: string;
  raw_code?: string | null;
  raw_system?: string | null;
  scope?: string;
  short_explanation: string;
  source_label?: string | null;
  source_ref_id?: string | null;
  suggested_checks?: string[];
  title?: string | null;
  what_it_means_here: string;
};
export type ClaimCaseHumanReview = {
  reasons?: string[];
  required: boolean;
};
export type ClaimCaseReviewLineFinancials = {
  allowed_cents?: number | null;
  amount_at_risk_cents?: number | null;
  charge_cents?: number | null;
  paid_cents?: number | null;
  patient_responsibility_cents?: number | null;
  provider_adjustment_cents?: number | null;
};
export type ClaimLineFindingKind =
  | "paid"
  | "denied"
  | "bundled"
  | "patient_responsibility"
  | "reversed"
  | "pending_secondary"
  | "unknown";
export type ClaimCaseReviewLineFinding = {
  billing_code?: BillingCodeRef2 | null;
  evidence_ref_ids?: string[];
  financials?: ClaimCaseReviewLineFinancials;
  finding_kind: ClaimLineFindingKind;
  headline: string;
  line_id?: string | null;
  service_date?: string | null;
};
export type PatientBillableStatus = "yes" | "no" | "unknown" | "not_applicable";
export type ClaimCasePatientBilling = {
  amount_cents?: number | null;
  billable_status: PatientBillableStatus;
  evidence_ref_ids?: string[];
  reason: string;
  requires_secondary_check: boolean;
  safety_warnings?: string[];
};
export type ClaimCaseReviewPatientBillingGate = {
  amount_cents?: number | null;
  evidence_ref_ids?: string[];
  hover_reason: string;
  plain_reason: string;
  requires_secondary_check?: boolean;
  status: PatientBillableStatus;
};
export type ClaimCaseReviewPrimaryFinding = {
  confidence_level: ConfidenceLevel;
  evidence_codes?: string[];
  evidence_ref_ids?: string[];
  summary: string;
  title: string;
};
export type ClaimLifecycleKind =
  | "clearinghouse_rejection"
  | "payer_frontend_rejection"
  | "payer_denial"
  | "partial_payment"
  | "patient_responsibility"
  | "secondary_pending"
  | "reversal_or_recoupment"
  | "unmatched_remittance"
  | "corrected_claim_resolved"
  | "documentation_request"
  | "manual_review"
  | "unknown";
export type ClaimRootCauseKind =
  | "missing_or_invalid_field"
  | "diagnosis_procedure_mismatch"
  | "modifier_or_code_issue"
  | "place_of_service_issue"
  | "coverage_or_eligibility"
  | "benefit_limitation_or_noncovered"
  | "authorization_or_referral"
  | "coordination_of_benefits"
  | "credentialing_or_enrollment"
  | "documentation_or_medical_necessity"
  | "timely_filing"
  | "duplicate_or_replacement"
  | "patient_responsibility"
  | "payer_processing"
  | "reversal_or_recoupment"
  | "matching_or_posting"
  | "insufficient_evidence"
  | "unknown";
export type ClaimCaseReviewProblem = {
  amount_at_risk_cents?: number | null;
  headline: string;
  label: string;
  lifecycle_kind: ClaimLifecycleKind;
  likely_root_cause: string;
  reason_codes?: string[];
  root_cause_kind: ClaimRootCauseKind;
  what_happened: string;
};
export type ClaimCaseReviewProblemExplanation = {
  confidence_level: ConfidenceLevel;
  evidence_ref_ids?: string[];
  headline: string;
  hover_explanation?: string | null;
  hover_summary: string;
  likely_root_cause?: string | null;
  plain_summary: string;
  recommended_next_step?: string | null;
  root_cause_summary: string;
  title: string;
  what_to_do_next: string;
};
export type ProposedChangeScope =
  | "claim_header"
  | "claim_line"
  | "diagnosis"
  | "modifier"
  | "payer"
  | "coverage"
  | "provider"
  | "authorization"
  | "documentation"
  | "ledger"
  | "other";
export type ClaimCaseProposedChange = {
  confirmation_owner_role?: string | null;
  current_value?: string | null;
  evidence_ref_ids?: string[];
  reason: string;
  requires_confirmation: boolean;
  scope: ProposedChangeScope;
  suggested_value?: string | null;
  target: string;
};
export type ClaimReviewPriority2 = "low" | "normal" | "high" | "urgent";
export type ClaimCaseReviewQueueSummary = {
  amount_at_risk_cents?: number | null;
  date_of_service: string;
  patient_display: string;
  payer_name: string;
  primary_billing_code?: BillingCodeRef2 | null;
  priority: ClaimReviewPriority2;
  provider_display: string;
  recommended_action_label: string;
  root_cause_label: string;
  service_type_label?: string | null;
  stage_label: string;
};
export type ClaimReviewLane2 =
  | "rejected_before_payer"
  | "payer_rework"
  | "coding_review"
  | "clinician_documentation"
  | "eligibility_registration"
  | "authorization"
  | "credentialing_enrollment"
  | "patient_responsibility_review"
  | "secondary_billing"
  | "reversal_recoupment"
  | "matching_posting"
  | "manual_review";
export type ClaimCaseActionRecommendation = {
  action_kind: ClaimActionKind;
  label: string;
  next_step_instruction: string;
  rationale: string;
  requires_human_confirmation: boolean;
};
export type ClaimCaseReviewRecommendation = {
  lane: ClaimReviewLane2;
  next_step_instruction: string;
  owner_role: ClaimOwnerRole2;
  primary_action: ClaimCaseActionRecommendation;
  rationale: string;
  secondary_actions?: ClaimCaseActionRecommendation[];
};
export type ClaimCaseReviewRecommendedAction = {
  confidence_level: ConfidenceLevel;
  details: string;
  label: string;
  owner_role: ClaimOwnerRole2;
  plain_instruction: string;
};
export type ReviewArtifactStatus =
  | "create_review"
  | "do_not_create_no_active_problem"
  | "do_not_create_superseded"
  | "do_not_create_unvalidated";
export type ClaimCaseReviewDisposition = {
  active_problem: boolean;
  artifact_status: ReviewArtifactStatus;
  reason: string;
  resolved_by_event_id?: string | null;
  superseded_by_event_id?: string | null;
};
export type ReviewKind = "claim_resolution_review";
export type ClaimCaseVerificationItem = {
  evidence_ref_ids?: string[];
  label: string;
  owner_role?: string | null;
  reason: string;
  required_before_primary_action: boolean;
};
export type ClaimCaseReviewResult = {
  action_summary: ClaimCaseReviewActionSummary;
  biller_note_md: string;
  clinician_request?: ClaimCaseClinicianRequest | null;
  confidence: ClaimCaseConfidence;
  do_not_do_yet?: ClaimCaseSafetyWarning[];
  evidence?: ClaimCaseEvidenceItem[];
  explained_codes?: ClaimCaseReviewExplainedCode[];
  human_review: ClaimCaseHumanReview;
  line_findings?: ClaimCaseReviewLineFinding[];
  open_questions?: string[];
  patient_billing: ClaimCasePatientBilling;
  patient_billing_gate: ClaimCaseReviewPatientBillingGate;
  primary_finding?: ClaimCaseReviewPrimaryFinding | null;
  problem: ClaimCaseReviewProblem;
  problem_explanation: ClaimCaseReviewProblemExplanation;
  proposed_changes?: ClaimCaseProposedChange[];
  queue_summary: ClaimCaseReviewQueueSummary;
  recommendation: ClaimCaseReviewRecommendation;
  recommended_action?: ClaimCaseReviewRecommendedAction | null;
  resolution_path_explanation: string;
  review_disposition: ClaimCaseReviewDisposition;
  review_kind: ReviewKind;
  schema_version?: string;
  trigger_event_kind: string;
  verify_before_acting?: ClaimCaseVerificationItem[];
};
export type ClaimCaseReviewDetail = {
  claim_case_review_id: string;
  confidence_level?: string | null;
  created_at?: string | null;
  primary_action_label?: string | null;
  priority?: string | null;
  resolution_path_explanation?: string | null;
  review_kind: string;
  root_cause_label?: string | null;
  schema_version: string;
  stage_label?: string | null;
  status: string;
  structured_output?: ClaimCaseReviewResult | null;
  trigger_claim_lifecycle_event_id?: string | null;
  updated_at?: string | null;
};
export type ClaimCaseDetailResponse = {
  claim_case: ClaimCase;
  latest_review?: ClaimCaseReviewDetail | null;
};
export type GenerateClaimCaseReviewResponse = {
  already_completed?: boolean;
  claim_id: string;
  claim_lifecycle_event_id: string;
  message: string;
  workflow_task_id?: string | null;
};
export type ClaimWorkViewCounts = {
  all_claim_work?: number;
  awaiting_payer?: number;
  bill_secondary?: number;
  fix?: number;
  /** Legacy alias for review + fix */
  needs_correction?: number;
  payer_in_progress?: number;
  payment_posted?: number;
  /** Legacy alias for submit */
  ready_to_submit?: number;
  review?: number;
  submit?: number;
};
export type ClaimWorkCounts = {
  computed_at: string;
  /** Rows a disposition hides across the queues, whether or not they are included */
  hidden_count?: number;
  matching_count?: number;
  work_view_counts?: ClaimWorkViewCounts;
};
export type ClaimWorkFindingHighlight = {
  blocks_submission?: boolean;
  disposition: string;
  finding_id: string;
  finding_key: string;
  observation: string;
  policy_id: string;
  remediation?: {
    [key: string]: any;
  } | null;
  submission_authority?: string | null;
  submission_authority_code?: string | null;
  target_kind: string;
  target_ref?: {
    [key: string]: any;
  };
  why?: string | null;
};
export type ClaimWorkPayerStatus = {
  code?: string | null;
  kind: string;
  occurred_at?: string | null;
};
export type ClaimWorkNoteSummary = {
  author_name?: string | null;
  author_principal_id?: string | null;
  author_principal_kind?: string | null;
  body: string;
  created_at?: string | null;
};
export type ClaimWorkOutcomeReason = {
  category?: string | null;
  codes?: string[];
};
export type ClaimPayerStateInvestigation = {
  detail: string;
  title: string;
};
export type ClaimWorkQueueKey =
  | "submit"
  | "review"
  | "awaiting_payer"
  | "fix"
  | "bill_secondary";
export type ClaimWorkReturnedReason =
  | "lifecycle_event"
  | "new_claim"
  | "snooze_expired";
export type EncounterWorkState = "active" | "snoozed" | "archived";
export type ClaimWorkDispositionSummary = {
  actor_name?: string | null;
  actor_principal_id?: string | null;
  actor_principal_kind?: string | null;
  hidden_until?: string | null;
  state: EncounterWorkState;
  updated_at?: string | null;
  version: number;
};
export type ClaimWorkItem = {
  active_advisory_count?: number;
  active_blocker_count?: number;
  active_finding_count?: number;
  amount_paid_cents?: number;
  balance_due_cents?: number;
  can_submit: boolean;
  certification_decision?: string | null;
  certification_freshness: string;
  certification_run_state: string;
  /** The payer's reference for the claim's chain: its own ICN, else the one a correction or void was filed against. The number to quote to the payer */
  chain_payer_reference?: string | null;
  claim_id: string;
  claim_lifecycle: string;
  /** The identifier the workbench shows as Claim # */
  claim_number?: string | null;
  clinician_display_name?: string | null;
  created_at?: string | null;
  /** Non-null for with_payer rows */
  days_silent?: number | null;
  encounter_id?: string | null;
  /** True when ERA triage flagged the remittance; false when triage cleared it or none ran. A partially paid claim enters Fix unless triage explicitly cleared it */
  era_needs_attention?: boolean;
  finding_highlights?: ClaimWorkFindingHighlight[];
  hidden?: boolean;
  last_payer_status?: ClaimWorkPayerStatus | null;
  latest_note?: ClaimWorkNoteSummary | null;
  legacy_error_count?: number;
  legacy_top_blocker?: string | null;
  legacy_warning_count?: number;
  organization_id: string;
  outcome_reason?: ClaimWorkOutcomeReason | null;
  paid_resolution_claim_id?: string | null;
  paid_resolution_reason?:
    | ("duplicate_of_paid_claim" | "resolved_by_paid_resubmission")
    | null;
  paid_resolution_remaining_issue_count?: number;
  paid_resolution_review_required?: boolean;
  paid_resolution_state?: ("resolved" | "reopened" | "invalidated") | null;
  parent_claim_id?: string | null;
  patient_control_number?: string | null;
  patient_id?: string | null;
  patient_name?: string | null;
  /** The payer's own ICN for the claim. Null until the payer adjudicates, and stays null when the clearinghouse rejects */
  payer_claim_control_number?: string | null;
  payer_name?: string | null;
  payer_outcome: string;
  payer_state_investigation?: ClaimPayerStateInvestigation | null;
  payer_uuid?: string | null;
  primary_claim_id?: string | null;
  /** occurred_at of the primary's driving 835 event */
  primary_era_at?: string | null;
  procedure_codes?: string[];
  provider_display_name?: string | null;
  provider_id?: string | null;
  queue?: ClaimWorkQueueKey | null;
  requires_correction: boolean;
  /** Set only while a non-active disposition exists but no longer hides */
  returned_reason?: ClaimWorkReturnedReason | null;
  /** A paid primary whose 835 left patient responsibility, was not forwarded, and whose patient has a position-2 coverage, with no live derived secondary yet */
  secondary_billable?: boolean;
  /** Patient responsibility left by the primary's driving 835 */
  secondary_billable_cents?: number | null;
  /** payer_unresolved, policy_order_disputed, primary_open_fix, primary_claim_number_missing */
  secondary_blockers?: string[];
  /** On a primary: its live derived secondary, any status */
  secondary_claim_id?: string | null;
  secondary_claim_status?: string | null;
  /** On a primary: the order-2 coverage's payer; on a secondary draft: its own payer */
  secondary_payer_name?: string | null;
  service_date?: string | null;
  service_date_to?: string | null;
  source_certification_id?: string | null;
  submission_blocker_count?: number;
  submission_blockers?: string[];
  submission_top_blocker?: string | null;
  submit_block_reason?: string | null;
  /** Anchors days_silent when the family has no payer event */
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge_cents?: number;
  updated_at?: string | null;
  work_disposition?: ClaimWorkDispositionSummary | null;
  work_notes_count?: number;
  work_state: string;
};
export type ClaimWorkListResponse = {
  counts: ClaimWorkCounts;
  items?: ClaimWorkItem[];
  next_cursor?: string | null;
};
export type ClaimWorkViewKey =
  | "all_claim_work"
  | "submit"
  | "review"
  | "awaiting_payer"
  | "fix"
  | "bill_secondary"
  | "payer_in_progress"
  | "payment_posted"
  | "ready_to_submit"
  | "needs_correction";
export type ClaimWorkSortKey =
  | "service_date_desc"
  | "service_date_asc"
  | "charge_desc"
  | "charge_asc"
  | "patient_asc"
  | "patient_desc";
export type ClaimWorkFilters = {
  claim_lifecycles?: string[];
  patient_ids?: string[];
  payer_ids?: string[];
  provider_ids?: string[];
  service_date_from?: string | null;
  service_date_to?: string | null;
  service_date_window_days?: number | null;
};
export type ClaimWorkSortKey2 =
  | "service_date_desc"
  | "service_date_asc"
  | "charge_desc"
  | "charge_asc"
  | "patient_asc"
  | "patient_desc";
export type ClaimWorkViewKey2 =
  | "all_claim_work"
  | "submit"
  | "review"
  | "awaiting_payer"
  | "fix"
  | "bill_secondary"
  | "payer_in_progress"
  | "payment_posted"
  | "ready_to_submit"
  | "needs_correction";
export type ClaimWorkSavedConfig = {
  filters?: ClaimWorkFilters;
  sort?: ClaimWorkSortKey2;
  visible_columns?: string[];
  work_view?: ClaimWorkViewKey2;
};
export type BillingSavedView = {
  billing_saved_view_id: string;
  config: ClaimWorkSavedConfig;
  created_at?: string | null;
  created_by_user_id: string;
  definition_version?: number;
  matching_count?: number | null;
  name: string;
  organization_id: string;
  surface?: string;
  updated_at?: string | null;
  updated_by_user_id: string;
  version?: number;
};
export type BillingSavedViewListResponse = {
  views?: BillingSavedView[];
};
export type ClaimWorkFilters2 = {
  claim_lifecycles?: string[];
  patient_ids?: string[];
  payer_ids?: string[];
  provider_ids?: string[];
  service_date_from?: string | null;
  service_date_to?: string | null;
  service_date_window_days?: number | null;
};
export type ClaimWorkSortKey3 =
  | "service_date_desc"
  | "service_date_asc"
  | "charge_desc"
  | "charge_asc"
  | "patient_asc"
  | "patient_desc";
export type ClaimWorkViewKey3 =
  | "all_claim_work"
  | "submit"
  | "review"
  | "awaiting_payer"
  | "fix"
  | "bill_secondary"
  | "payer_in_progress"
  | "payment_posted"
  | "ready_to_submit"
  | "needs_correction";
export type ClaimWorkSavedConfig2 = {
  filters?: ClaimWorkFilters2;
  sort?: ClaimWorkSortKey3;
  visible_columns?: string[];
  work_view?: ClaimWorkViewKey3;
};
export type BillingSavedViewResponse = {
  billing_saved_view_id: string;
  config: ClaimWorkSavedConfig2;
  created_at?: string | null;
  created_by_user_id: string;
  definition_version?: number;
  matching_count?: number | null;
  name: string;
  organization_id: string;
  surface?: string;
  updated_at?: string | null;
  updated_by_user_id: string;
  version?: number;
};
export type ClaimWorkFilters3 = {
  claim_lifecycles?: string[];
  patient_ids?: string[];
  payer_ids?: string[];
  provider_ids?: string[];
  service_date_from?: string | null;
  service_date_to?: string | null;
  service_date_window_days?: number | null;
};
export type ClaimWorkSortKey4 =
  | "service_date_desc"
  | "service_date_asc"
  | "charge_desc"
  | "charge_asc"
  | "patient_asc"
  | "patient_desc";
export type ClaimWorkViewKey4 =
  | "all_claim_work"
  | "submit"
  | "review"
  | "awaiting_payer"
  | "fix"
  | "bill_secondary"
  | "payer_in_progress"
  | "payment_posted"
  | "ready_to_submit"
  | "needs_correction";
export type ClaimWorkSavedConfig3 = {
  filters?: ClaimWorkFilters3;
  sort?: ClaimWorkSortKey4;
  visible_columns?: string[];
  work_view?: ClaimWorkViewKey4;
};
export type CreateBillingSavedViewRequest = {
  config: ClaimWorkSavedConfig3;
  definition_version?: number;
  name: string;
};
export type DeleteBillingSavedViewResponse = {
  deleted?: boolean;
};
export type ClaimWorkFilters4 = {
  claim_lifecycles?: string[];
  patient_ids?: string[];
  payer_ids?: string[];
  provider_ids?: string[];
  service_date_from?: string | null;
  service_date_to?: string | null;
  service_date_window_days?: number | null;
};
export type ClaimWorkSortKey5 =
  | "service_date_desc"
  | "service_date_asc"
  | "charge_desc"
  | "charge_asc"
  | "patient_asc"
  | "patient_desc";
export type ClaimWorkViewKey5 =
  | "all_claim_work"
  | "submit"
  | "review"
  | "awaiting_payer"
  | "fix"
  | "bill_secondary"
  | "payer_in_progress"
  | "payment_posted"
  | "ready_to_submit"
  | "needs_correction";
export type ClaimWorkSavedConfig4 = {
  filters?: ClaimWorkFilters4;
  sort?: ClaimWorkSortKey5;
  visible_columns?: string[];
  work_view?: ClaimWorkViewKey5;
};
export type UpdateBillingSavedViewRequest = {
  config: ClaimWorkSavedConfig4;
  definition_version?: number;
  expected_version: number;
  name: string;
};
export type AttentionDisposition = {
  dismissed_at?: string | null;
  dismissed_by?: string | null;
  snoozed_until?: string | null;
};
export type AttentionLane =
  | "payer_rework"
  | "patient_billing"
  | "reversal"
  | "manual_review"
  | "cob_review";
export type EraTriage = {
  attention_lane?: AttentionLane | null;
  needs_attention: boolean;
  signals?: string[];
  summary: string;
};
export type WhatToDo = {
  /** True if requires user action */
  is_actionable: boolean;
  /** Severity: error, warning, success, info */
  severity: string;
  /** Untruncated action description */
  text: string;
};
export type ClaimV2Item = {
  /** User dismiss/snooze state */
  attention_disposition?: AttentionDisposition | null;
  /** Balance due in cents */
  balance_due_cents?: number | null;
  /** Claim ID */
  claim_id: string;
  /** Claim type: original, corrected, or void */
  claim_type?: string | null;
  /** Linked encounter ID */
  encounter_id?: string | null;
  /** ERA triage decision from 835 processing */
  era_triage?: EraTriage | null;
  /** Scrubbing/validation error count */
  error_count?: number;
  /** Parent claim ID — set when this is a correction or void */
  parent_claim_id?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Payer UUID */
  payer_id?: string | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** UI phase: drafts, ready, inFlight, paid, review, imported */
  phase: string;
  /** Display label for phase */
  phase_label: string;
  /** Provider ID */
  provider_id?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Original 14-value status for drill-down */
  raw_status: string;
  /** Service date (ISO 8601) */
  service_date?: string | null;
  /** ID of the correction/void claim that supersedes this one */
  superseded_by_claim_id?: string | null;
  /** Total charge in cents */
  total_charge_cents?: number | null;
  /** Warning count */
  warning_count?: number;
  /** Actionable instruction */
  what_to_do: WhatToDo;
};
export type SegmentCount2 = {
  /** Number of items in this segment */
  count: number;
  /** Segment key */
  key: string;
  /** Display label */
  label: string;
  /** Color hint: error, warning, success, or null */
  severity?: string | null;
};
export type ClaimsV2Response = {
  /** Claim rows */
  claims: ClaimV2Item[];
  /** Current page */
  page: number;
  /** Items per page */
  per_page: number;
  /** Phase-grouped segment counts */
  segments: SegmentCount2[];
  /** Human-readable summary line */
  summary: string;
  /** Total matching claims */
  total: number;
  /** Total pages */
  total_pages: number;
};
export type PaidClaimServiceItem = {
  claim_line_id: string;
  cpt_code: string;
  date_from: string;
  date_to: string;
  encounter_id?: string | null;
  modifiers?: string[];
  net_paid_cents?: number | null;
  rendering_provider_npi: string;
  units: string;
};
export type PaidClaimEvidenceItem = {
  claim_id: string;
  claim_number?: string | null;
  coverage_id?: string | null;
  patient_id: string;
  payer_id: string;
  payer_name?: string | null;
  payer_responsibility: "P" | "S" | "T";
  provider_id: string;
  provider_name?: string | null;
  services?: PaidClaimServiceItem[];
  status: string;
  submitted_at: string;
};
export type PaidClaimPaymentEvidence = {
  ledger_entry_ids?: string[];
  net_paid_cents: number;
  payment_date?: string | null;
  remaining_insurance_cents: number;
  remittance_claim_ids?: string[];
  remittance_ids?: string[];
  reversal_recorded?: boolean;
};
export type PaidClaimResolutionCandidate = {
  evidence_token: string;
  failed_claim: PaidClaimEvidenceItem;
  issue_keys?: string[];
  mode: "manual" | "automatic";
  paid_claim: PaidClaimEvidenceItem;
  payment: PaidClaimPaymentEvidence;
  reason: "duplicate_of_paid_claim" | "resolved_by_paid_resubmission";
};
export type PaidClaimResolutionHistoryItem = {
  actor_name?: string | null;
  actor_principal_id: string;
  actor_principal_kind: string;
  event_id: string;
  invalidation_reason?:
    | (
        | "payment_changed"
        | "service_match_changed"
        | "supporting_claim_unavailable"
      )
    | null;
  kind: "resolved" | "reopened" | "invalidated";
  mode: "manual" | "automatic";
  note?: string | null;
  occurred_at: string;
  paid_claim_id: string;
  reason: "duplicate_of_paid_claim" | "resolved_by_paid_resubmission";
  version: number;
};
export type PaidClaimResolutionItem = {
  actor_name?: string | null;
  actor_principal_id: string;
  actor_principal_kind: string;
  claim_id: string;
  evidence: PaidClaimResolutionCandidate;
  invalidation_reason?:
    | (
        | "payment_changed"
        | "service_match_changed"
        | "supporting_claim_unavailable"
      )
    | null;
  issue_keys?: string[];
  mode: "manual" | "automatic";
  note?: string | null;
  paid_claim_id: string;
  reason: "duplicate_of_paid_claim" | "resolved_by_paid_resubmission";
  resolution_id: string;
  resolved_at: string;
  state: "resolved" | "reopened" | "invalidated";
  updated_at: string;
  version: number;
};
export type PaidClaimResolutionReviewResponse = {
  archived?: boolean;
  can_reopen?: boolean;
  can_resolve?: boolean;
  candidate?: PaidClaimResolutionCandidate | null;
  claim_id: string;
  encounter_id?: string | null;
  history?: PaidClaimResolutionHistoryItem[];
  independent_task_count?: number;
  ineligibility_reason?:
    | (
        | "not_failed"
        | "insufficient_issue_evidence"
        | "no_paid_match"
        | "ambiguous_paid_match"
        | "incomplete_service_match"
        | "invalid_payment"
        | "archived"
        | "evidence_changed"
      )
    | null;
  message: string;
  remaining_issue_count?: number;
  resolution?: PaidClaimResolutionItem | null;
  status: "eligible" | "unavailable" | "resolved" | "reopened" | "invalidated";
  version?: number;
};
export type PaidClaimServiceItem2 = {
  claim_line_id: string;
  cpt_code: string;
  date_from: string;
  date_to: string;
  encounter_id?: string | null;
  modifiers?: string[];
  net_paid_cents?: number | null;
  rendering_provider_npi: string;
  units: string;
};
export type PaidClaimEvidenceItem2 = {
  claim_id: string;
  claim_number?: string | null;
  coverage_id?: string | null;
  patient_id: string;
  payer_id: string;
  payer_name?: string | null;
  payer_responsibility: "P" | "S" | "T";
  provider_id: string;
  provider_name?: string | null;
  services?: PaidClaimServiceItem2[];
  status: string;
  submitted_at: string;
};
export type PaidClaimPaymentEvidence2 = {
  ledger_entry_ids?: string[];
  net_paid_cents: number;
  payment_date?: string | null;
  remaining_insurance_cents: number;
  remittance_claim_ids?: string[];
  remittance_ids?: string[];
  reversal_recorded?: boolean;
};
export type PaidClaimResolutionCandidate2 = {
  evidence_token: string;
  failed_claim: PaidClaimEvidenceItem2;
  issue_keys?: string[];
  mode: "manual" | "automatic";
  paid_claim: PaidClaimEvidenceItem2;
  payment: PaidClaimPaymentEvidence2;
  reason: "duplicate_of_paid_claim" | "resolved_by_paid_resubmission";
};
export type PaidClaimResolutionHistoryItem2 = {
  actor_name?: string | null;
  actor_principal_id: string;
  actor_principal_kind: string;
  event_id: string;
  invalidation_reason?:
    | (
        | "payment_changed"
        | "service_match_changed"
        | "supporting_claim_unavailable"
      )
    | null;
  kind: "resolved" | "reopened" | "invalidated";
  mode: "manual" | "automatic";
  note?: string | null;
  occurred_at: string;
  paid_claim_id: string;
  reason: "duplicate_of_paid_claim" | "resolved_by_paid_resubmission";
  version: number;
};
export type PaidClaimResolutionItem2 = {
  actor_name?: string | null;
  actor_principal_id: string;
  actor_principal_kind: string;
  claim_id: string;
  evidence: PaidClaimResolutionCandidate2;
  invalidation_reason?:
    | (
        | "payment_changed"
        | "service_match_changed"
        | "supporting_claim_unavailable"
      )
    | null;
  issue_keys?: string[];
  mode: "manual" | "automatic";
  note?: string | null;
  paid_claim_id: string;
  reason: "duplicate_of_paid_claim" | "resolved_by_paid_resubmission";
  resolution_id: string;
  resolved_at: string;
  state: "resolved" | "reopened" | "invalidated";
  updated_at: string;
  version: number;
};
export type PaidClaimResolutionReviewResponse2 = {
  archived?: boolean;
  can_reopen?: boolean;
  can_resolve?: boolean;
  candidate?: PaidClaimResolutionCandidate2 | null;
  claim_id: string;
  encounter_id?: string | null;
  history?: PaidClaimResolutionHistoryItem2[];
  independent_task_count?: number;
  ineligibility_reason?:
    | (
        | "not_failed"
        | "insufficient_issue_evidence"
        | "no_paid_match"
        | "ambiguous_paid_match"
        | "incomplete_service_match"
        | "invalid_payment"
        | "archived"
        | "evidence_changed"
      )
    | null;
  message: string;
  remaining_issue_count?: number;
  resolution?: PaidClaimResolutionItem2 | null;
  status: "eligible" | "unavailable" | "resolved" | "reopened" | "invalidated";
  version?: number;
};
export type PaidClaimResolutionConflictResponse = {
  current: PaidClaimResolutionReviewResponse2;
  error_code?: "paid_resolution_conflict";
  message: string;
  reason:
    | "evidence_changed"
    | "version_changed"
    | "restore_required"
    | "not_eligible"
    | "operation_conflict";
};
export type PaidClaimResolutionReopenRequest = {
  expected_version: number;
  note?: string | null;
  operation_id: string;
};
export type PaidClaimResolutionRequest = {
  evidence_token: string;
  expected_version: number;
  note?: string | null;
  operation_id: string;
  paid_claim_id: string;
};
export type EncounterWorkState2 = "active" | "snoozed" | "archived";
export type EncounterWorkDispositionItem = {
  /** Display name for the acting principal, null when it has no directory entry (an agent, a system job) */
  actor_name?: string | null;
  /** The claim on screen when the decision was made */
  claim_id?: string | null;
  encounter_id: string;
  /** Instant the snooze lifts; null unless snoozed */
  hidden_until?: string | null;
  state: EncounterWorkState2;
  updated_at?: string | null;
  version: number;
};
export type EncounterWorkNoteItem = {
  /** Display name for the author, null when the principal has no directory entry */
  author_name?: string | null;
  /** The author's principal id; edit and delete are theirs alone */
  author_principal_id?: string | null;
  body: string;
  claim_id?: string | null;
  created_at?: string | null;
  /** Instant the author's window to edit or delete closes */
  editable_until: string;
  /** Instant of the latest edit; null until one */
  edited_at?: string | null;
  id: string;
  /** Concurrency token: echo it back verbatim as expected_updated_at on an edit. Opaque — reformatting it (e.g. through Date) drops microseconds and reads as stale. */
  updated_at: string;
};
export type EncounterWorkDispositionResponse = {
  disposition: EncounterWorkDispositionItem;
  note?: EncounterWorkNoteItem | null;
};
export type EncounterWorkState3 = "active" | "snoozed" | "archived";
export type EncounterWorkDispositionItem2 = {
  /** Display name for the acting principal, null when it has no directory entry (an agent, a system job) */
  actor_name?: string | null;
  /** The claim on screen when the decision was made */
  claim_id?: string | null;
  encounter_id: string;
  /** Instant the snooze lifts; null unless snoozed */
  hidden_until?: string | null;
  state: EncounterWorkState3;
  updated_at?: string | null;
  version: number;
};
export type EncounterWorkConflictResponse = {
  current?: EncounterWorkDispositionItem2 | null;
  error_code?: string;
  message: string;
  status?: number;
};
export type EncounterWorkAction = "archive" | "snooze" | "restore";
export type EncounterWorkDispositionRequest = {
  /** archive, snooze or restore */
  action: EncounterWorkAction;
  /** The claim the decision was made on */
  claim_id?: string | null;
  /** Optimistic concurrency guard; 409 on mismatch */
  expected_version?: number | null;
  /** Optional note written in the same dialog */
  note?: string | null;
  /** Snooze only, YYYY-MM-DD. The server resolves it to 09:00 in the organization's timezone. */
  until_date?: string | null;
};
export type EncounterWorkState4 = "active" | "snoozed" | "archived";
export type EncounterWorkDispositionItem3 = {
  /** Display name for the acting principal, null when it has no directory entry (an agent, a system job) */
  actor_name?: string | null;
  /** The claim on screen when the decision was made */
  claim_id?: string | null;
  encounter_id: string;
  /** Instant the snooze lifts; null unless snoozed */
  hidden_until?: string | null;
  state: EncounterWorkState4;
  updated_at?: string | null;
  version: number;
};
export type EncounterWorkNoteItem2 = {
  /** Display name for the author, null when the principal has no directory entry */
  author_name?: string | null;
  /** The author's principal id; edit and delete are theirs alone */
  author_principal_id?: string | null;
  body: string;
  claim_id?: string | null;
  created_at?: string | null;
  /** Instant the author's window to edit or delete closes */
  editable_until: string;
  /** Instant of the latest edit; null until one */
  edited_at?: string | null;
  id: string;
  /** Concurrency token: echo it back verbatim as expected_updated_at on an edit. Opaque — reformatting it (e.g. through Date) drops microseconds and reads as stale. */
  updated_at: string;
};
export type EncounterWorkNotesResponse = {
  disposition?: EncounterWorkDispositionItem3 | null;
  notes?: EncounterWorkNoteItem2[];
};
export type EncounterWorkNoteItem3 = {
  /** Display name for the author, null when the principal has no directory entry */
  author_name?: string | null;
  /** The author's principal id; edit and delete are theirs alone */
  author_principal_id?: string | null;
  body: string;
  claim_id?: string | null;
  created_at?: string | null;
  /** Instant the author's window to edit or delete closes */
  editable_until: string;
  /** Instant of the latest edit; null until one */
  edited_at?: string | null;
  id: string;
  /** Concurrency token: echo it back verbatim as expected_updated_at on an edit. Opaque — reformatting it (e.g. through Date) drops microseconds and reads as stale. */
  updated_at: string;
};
export type EncounterWorkNoteResponse = {
  note: EncounterWorkNoteItem3;
};
export type EncounterWorkNoteRequest = {
  body: string;
  /** The claim on screen when the note was written */
  claim_id?: string | null;
};
export type EncounterWorkNoteEditRequest = {
  body: string;
  /** The note's updated_at exactly as last read, echoed verbatim; 409 stale_note when it has moved since */
  expected_updated_at: string;
};
export type ActivityFeedEvent = {
  /** Entity ID for linking */
  link_id?: string | null;
  /** Entity type: claim, remittance, patient */
  link_type?: string | null;
  /** Patient ID for navigation */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** 'error' for denials/failures, null otherwise */
  severity?: string | null;
  /** Human-readable event description */
  text: string;
  /** ISO 8601 timestamp */
  timestamp: string;
  /** Event type: era_received, claim_created, claim_denied, payment_received, etc. */
  type: string;
};
export type ActivityFeedGroup = {
  events?: ActivityFeedEvent[];
  /** Date group: 'Today', 'Yesterday', or date string */
  group: string;
};
export type FlowHealthRow = {
  /** Total count */
  denominator?: number;
  /** Funnel label: 'Encounters → Claims' */
  label: string;
  /** Display metric: '85%' or '$7,800' */
  metric?: string;
  /** Converted count */
  numerator?: number;
};
export type SummaryStrip = {
  /** Collections last month */
  collected_last_month_cents?: number;
  /** Collections this month */
  collected_this_month_cents?: number;
  /** Trend vs last month (e.g. 12.0 for +12%) */
  collected_trend_pct?: number | null;
  /** Claims in flight */
  in_flight_count?: number;
  /** Breakdown: '5 denied, 3 errors, 6 ready to send' */
  needs_action_breakdown?: string | null;
  /** Items needing attention */
  needs_action_count?: number;
  /** Total patient accounts receivable */
  patient_ar_cents?: number;
  /** Patients with balance > 0 */
  patient_ar_count?: number;
  /** Age of oldest outstanding balance */
  patient_ar_oldest_days?: number;
};
export type BillingOverviewResponse = {
  /** Recent billing events grouped by date */
  activity_feed?: ActivityFeedGroup[];
  /** Top 5 work items (from work queue service) */
  attention_items?: {
    [key: string]: any;
  }[];
  /** Conversion funnels */
  flow_health?: FlowHealthRow[];
  /** Top-level metrics */
  summary: SummaryStrip;
};
export type PatientQueueItem = {
  /** Current patient balance in cents */
  balance_cents: number;
  /** Number of eligible charge lines */
  charge_line_count: number;
  /** Eligible charge line IDs */
  charge_line_ids?: string[];
  /** Service date range (e.g. 'Feb 20 – Mar 10') */
  date_range?: string | null;
  /** Number of encounters with charges */
  encounter_count: number;
  /** When the latest invoice was sent OR last reminded (ISO 8601). Drives the suppression window and the reminder-state badge. */
  latest_action_at?: string | null;
  /** ID of the most recent non-void invoice for this patient. Pass to POST /v2/provider/invoices/{id}/remind to send a reminder. */
  latest_invoice_id?: string | null;
  /** Patient billing account ID */
  patient_billing_account_id: string;
  /** Patient ID */
  patient_id: string;
  /** Patient display name */
  patient_name?: string | null;
  /** When queued (ISO 8601) */
  queued_at?: string | null;
  /** Number of reminders already sent for the latest invoice. */
  reminder_count?: number;
  /** Statement run ID */
  statement_run_id: string;
  /** Plain-English explanation of why patient owes */
  why: string;
};
export type PatientBillingQueueSummary = {
  /** Number of patients in queue */
  count: number;
  /** Age of oldest queued item in days */
  oldest_days?: number;
  /** Total balance across all patients */
  total_cents: number;
};
export type PatientBillingQueueResponse = {
  /** Queue items */
  items: PatientQueueItem[];
  page: number;
  per_page: number;
  /** Queue summary stats */
  summary: PatientBillingQueueSummary;
  total: number;
  total_pages: number;
};
export type SentInvoiceItem = {
  /** Invoice amount in cents */
  amount_cents: number;
  /** When invoice was created (ISO 8601) */
  created_at: string;
  /** How the invoice was delivered */
  delivery_method?: string;
  /** Linked encounter ID */
  encounter_id?: string | null;
  /** Internal invoice ID */
  invoice_id: string;
  /** Human-readable outcome: 'Paid Mar 25' or 'Open — awaiting payment' */
  outcome: string;
  /** When paid (ISO 8601) */
  paid_at?: string | null;
  /** Patient ID */
  patient_id: string;
  /** Patient display name */
  patient_name?: string | null;
  /** Whether patient received notification */
  patient_notified?: boolean;
  /** Stripe payment link URL */
  payment_url?: string | null;
  /** Who triggered the invoice */
  sent_by?: string | null;
  /** Invoice status: paid, open, void, etc. */
  status: string;
  /** Stripe invoice ID */
  stripe_invoice_id: string;
};
export type SentInvoicesSummary = {
  /** Total sent invoices */
  count: number;
  /** Number of failed/void invoices */
  failed_count?: number;
  /** Number of open invoices */
  open_count?: number;
  /** Number of paid invoices */
  paid_count?: number;
  /** Total paid amount */
  paid_total_cents?: number;
  /** Total invoiced amount */
  total_cents: number;
};
export type SentInvoicesResponse = {
  /** Invoice items */
  items: SentInvoiceItem[];
  page: number;
  per_page: number;
  /** Sent summary stats */
  summary: SentInvoicesSummary;
  total: number;
  total_pages: number;
};
export type AssignChargeToEncounterResponse = {
  /** Amount moved onto the encounter, in cents. Same as assigned_cents; kept because it shipped first. */
  amount_cents: number;
  /** How much of the charge landed on the encounter — capped at what the encounter still owed. */
  assigned_cents: number;
  charge_line_id: string;
  /** The remainder, left as unapplied account credit because the charge was larger than the encounter's balance. Zero on an exact fit. Not applied anywhere else: which visit it belongs to is the biller's call, through the Apply-credit verb. */
  credited_cents: number;
  source_ledger_entry_id: string;
  target_encounter_id: string;
  target_ledger_entry_id: string;
};
export type AssignChargeToEncounterRequest = {
  /** The account-level charge that stood in for the encounter. Also the idempotency key: one stand-in backs one assignment, so a retry completes and a repeat cannot draw credit twice. */
  charge_line_id: string;
  /** Optional reason recorded on the correction. */
  note?: string | null;
  /** Encounter the money was actually for. Chosen by the biller, never inferred — amounts alone cannot distinguish an encounter's deductible from an over-collection, and a wrong guess misstates what a patient owes. */
  target_encounter_id: string;
};
export type CreditAllocationResponse = {
  allocation_id: string;
  amount_cents: number;
  source_encounter_id?: string | null;
  source_ledger_entry_id: string;
  target_encounter_id: string;
  target_ledger_entry_id: string;
};
export type CreditAllocationRequest = {
  /** Client-generated UUID. Baked into the ledger entries' source ids so a retried confirm is idempotent. */
  allocation_id: string;
  /** Amount to apply, in cents (positive). */
  amount_cents: number;
  /** Encounter holding the credit; null draws from the account-level credit. */
  source_encounter_id?: string | null;
  /** Encounter the credit is applied to. */
  target_encounter_id: string;
};
export type PatientDueStatus =
  | "estimated"
  | "operational_expected"
  | "pending_secondary"
  | "confirmed"
  | "denied"
  | "invoiced"
  | "paid"
  | "written_off"
  | "in_collections"
  | "void";
export type AccountActivitySourceView = {
  /** Always unsigned */
  amount_cents: number;
  /** ISO date */
  date?: string | null;
  /** The ledger entry this came from */
  entry_id: string;
  /** Ledger entry type, e.g. 'payment' or 'reversal'. Scopes which verbs a client may offer on this source. */
  entry_type: string;
  label: string;
};
export type AccountActivityRowView = {
  /** Always unsigned */
  amount_cents: number;
  /** ISO date for timeline ordering */
  date?: string | null;
  detail?: string | null;
  /** charge_line:{id} or account:unapplied-credit */
  id: string;
  /** Active invoice this outstanding charge rides on, if any */
  invoice_id?: string | null;
  label: string;
  /** The charge line's patient-due lifecycle state. Null only on the synthetic account:unapplied-credit row, which is collapsed ledger entries rather than a charge line and so has no such state. `tone` cannot stand in for this: paid and written_off are both 'ok' and differ only in display copy, so a client deciding which verbs a row supports must read this rather than match on `detail`. */
  patient_due_status?: PatientDueStatus | null;
  /** Credit-side events behind an unapplied-credit row (payments, reversals) — history, not arithmetic */
  sources?: AccountActivitySourceView[] | null;
  tone: "ok" | "due" | "info";
};
export type LedgerEntrySourceRef = {
  id?: string | null;
  type: string;
};
export type LedgerEntryItem = {
  actor_user_id?: string | null;
  amount_cents: number;
  created_at: string;
  description?: string | null;
  entry_id: string;
  entry_type: string;
  entry_type_label: string;
  party_type: string;
  source_ref?: LedgerEntrySourceRef | null;
};
export type PatientBillingStatus = {
  /** How the last invoice was delivered */
  last_invoice_delivery_method?: string | null;
  /** When the last invoice was sent (ISO 8601) */
  last_invoice_sent_at?: string | null;
  /** When the ERA queue item was created (ISO 8601) */
  queued_at?: string | null;
  /** Billing status code */
  status:
    | "in_queue"
    | "open_invoice"
    | "balance_due"
    | "paid"
    | "credit"
    | "no_activity";
  /** Human-readable label, rendered as-is */
  status_label: string;
};
export type ActivityLineView = {
  /** Always unsigned */
  amount_cents: number;
  detail?: string | null;
  /** charge_line:{id} or entry:{id} */
  id: string;
  label: string;
  tone: "ok" | "due" | "info";
};
export type EncounterAdjustmentsSplit = {
  insurance_adjustment_cents?: number;
  other_cents?: number;
  write_off_cents?: number;
};
export type ChargeLineItem = {
  adjusted_cents?: number;
  allowed_cents?: number | null;
  charge_line_id: string;
  charged_cents?: number;
  cpt_code?: string | null;
  description?: string | null;
  insurance_paid_cents?: number;
  patient_paid_cents?: number;
  patient_responsibility_cents?: number | null;
  status?: string;
  units?: number;
};
export type EncounterClaimSummary = {
  claim_id: string;
  paid_at?: string | null;
  status: string;
  status_label: string;
  submitted_at?: string | null;
  total_charge_cents?: number;
};
export type PatientResponsibilityBreakdown = {
  coinsurance_cents?: number;
  copay_cents?: number;
  deductible_cents?: number;
  other_cents?: number;
};
export type PatientResponsibilityReconciliationView = {
  active_invoice_cents?: number;
  active_invoice_ids?: string[];
  collected_cents?: number;
  confirmed_cents?: number;
  confirmed_line_ids?: string[];
  credit_cents?: number;
  estimate_line_ids?: string[];
  estimated_cents?: number;
  /** Biller-facing explanation */
  explanation: string;
  /** Biller-facing one-line summary */
  headline: string;
  payment_entry_ids?: string[];
  /** none, send_invoice, send_reminder, review_credit_or_refund, suspend_invoice_wait_secondary, review_denial */
  recommended_action: string;
  remaining_due_cents?: number;
  stale_invoice_ids?: string[];
  /** Reconciliation state machine value, e.g. matched, under_collected, over_collected, estimate_pending_era, secondary_pending_suspended. */
  state: string;
};
export type EncounterLedgerGroup = {
  /** Plain-language lifecycle lines — one event per charge, unsigned amounts, no contra pairs (gdn-2941) */
  activity_lines?: ActivityLineView[];
  /** Adjustments (kept for backwards compat) */
  adjusted_cents?: number;
  /** Adjustments split by type */
  adjustments?: EncounterAdjustmentsSplit | null;
  /** CPT-level charge line breakdown */
  charge_lines?: ChargeLineItem[];
  /** Total charges for this encounter */
  charged_cents?: number;
  /** Most recent claim for this encounter, null if no claim filed */
  claim?: EncounterClaimSummary | null;
  /** Payer-side billed amount only (claim charges, no patient charge lines) — the receipt breakdown's top line (gdn-2940) */
  claim_billed_cents?: number;
  /** Encounter ID */
  encounter_id?: string | null;
  /** Encounter type + primary CPT, e.g. 'Follow-up — 90834' */
  encounter_type_label?: string | null;
  /** Ledger entries for this encounter */
  entries?: LedgerEntryItem[];
  /** Insurance paid */
  insurance_paid_cents?: number;
  /** Invoice IDs from the top-level invoices[] that belong to this encounter */
  linked_invoice_ids?: string[];
  /** Remaining balance */
  patient_balance_cents?: number;
  /** Patient responsibility */
  patient_due_cents?: number;
  /** Patient paid */
  patient_paid_cents?: number;
  /** Copay/coinsurance/deductible split, null pre-adjudication */
  patient_responsibility_breakdown?: PatientResponsibilityBreakdown | null;
  /** Derived estimate-to-confirmed patient responsibility state for this encounter. */
  patient_responsibility_reconciliation?: PatientResponsibilityReconciliationView | null;
  /** Primary insurance payer name, null if self-pay */
  primary_payer_name?: string | null;
  /** Provider user ID */
  provider_id?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Service date */
  service_date?: string | null;
};
export type PatientInvoiceHistoryItem = {
  amount_cents: number;
  created_at: string;
  delivery_method?: string;
  encounter_id?: string | null;
  invoice_id: string;
  /** Timestamp of the most recent declined payment attempt, or null if none has failed. A decline leaves the invoice open, so this is the only signal that one was attempted. */
  last_payment_failed_at?: string | null;
  /** Stripe's decline reason for the most recent failure. */
  last_payment_failure_reason?: string | null;
  /** Timestamp of the most recent reminder send, or null if the patient has not been chased since the invoice went out. */
  last_reminded_at?: string | null;
  /** When Stripe will next attempt this card, or null if it has stopped retrying or never auto-charges this invoice. A decline with retries pending may still resolve on its own; one with none left goes nowhere until someone acts. */
  next_payment_attempt_at?: string | null;
  paid_at?: string | null;
  /** How many payment attempts on this invoice have failed. */
  payment_failure_count?: number;
  payment_url?: string | null;
  /** How many reminders have been sent for this invoice. */
  reminder_count?: number;
  status: string;
};
export type PatientFinancialSummaryTotals = {
  /** Credit balance (negative patient balance = credit) */
  credit_balance_cents?: number;
  /** Payer-party balance */
  insurance_owed_cents?: number;
  /** Most recent payment date */
  last_payment_date?: string | null;
  /** Patient-party balance */
  patient_owed_cents?: number;
  /** Sum of adjustments */
  total_adjustments_cents?: number;
  /** Current patient balance (positive = owes) */
  total_balance_cents?: number;
  /** Sum of all charges */
  total_charges_cents?: number;
  /** Sum of payer payments */
  total_insurance_paid_cents?: number;
  /** Sum of patient payments */
  total_patient_paid_cents?: number;
};
export type PatientFinancialSummaryResponse = {
  /** Account-level lifecycle rollup (gdn-2948): dated business-event rows for the gated balance timeline, one per non-void account charge line plus proven unapplied credit. None when the rollup cannot reconcile to the account balance — fall back to account_level_entries. */
  account_activity_rows?: AccountActivityRowView[] | null;
  /** Account-level credit the allocation verb (gdn-2950) will accept: cash held at the account scope net of obligations still owed there. May be lower than the rollup's gross credit row — offer this amount, not the row amount. */
  account_allocatable_credit_cents?: number;
  /** Ledger entries not linked to a specific encounter (e.g. account-level write-offs, standalone charges). Excluded from encounters[] — render in the full transaction ledger. */
  account_level_entries?: LedgerEntryItem[];
  /** Computed billing status for the PatientResponsibilityPanel */
  billing_status: PatientBillingStatus;
  /** Encounter-grouped ledger entries */
  encounters?: EncounterLedgerGroup[];
  /** Invoice history */
  invoices?: PatientInvoiceHistoryItem[];
  patient_billing_account_id?: string | null;
  patient_id: string;
  patient_name?: string | null;
  summary: PatientFinancialSummaryTotals;
};
export type RefundablePaymentItem = {
  amount_cents: number;
  date?: string | null;
  description?: string | null;
  payment_ledger_entry_id: string;
  provenance: "external" | "stripe";
  refundable_remainder_cents?: number;
  refunded_cents?: number;
};
export type RefundablePaymentsResponse = {
  /** Cash-backed credit at the scope — the second cap on any refund amount. */
  available_credit_cents?: number;
  payments?: RefundablePaymentItem[];
  source_encounter_id?: string | null;
};
export type PatientRefundResponse = {
  amount_cents: number;
  method: "external" | "stripe";
  payment_ledger_entry_id: string;
  refund_id: string;
  refund_ledger_entry_id: string;
  source_encounter_id?: string | null;
};
export type PatientRefundRequest = {
  /** Amount to refund, in cents (positive). */
  amount_cents: number;
  /** 'stripe' executes the refund against the payment's Stripe payment intent; 'external' records one the practice already issued outside Stripe. */
  method: "external" | "stripe";
  note?: string | null;
  /** The payment the refund anchors to. */
  payment_ledger_entry_id: string;
  /** Client-generated UUID baked into the ledger entry's source id so a retried confirm is idempotent. */
  refund_id: string;
};
export type BillingPayerOptionRow = {
  /** Payer logo URL */
  avatar_url?: string | null;
  /** Distinct patients associated with this payer via current coverage or any claim submitted under it */
  patient_count: number;
  /** Payer display name */
  payer_name: string;
  /** Internal payer UUID */
  payer_uuid: string;
};
export type BillingPayerOptionsResponse = {
  /** Selectable payers sorted by patient count descending */
  payers: BillingPayerOptionRow[];
};
export type RemittanceV2Item = {
  /** Number of claims in this ERA */
  claim_count?: number;
  /** Created timestamp */
  created_at?: string | null;
  /** Number of denied claims */
  denial_count?: number;
  /** Outcome classification: clean, denials, reversals */
  outcome: string;
  /** Human-readable outcome: 'Clean', '8 denied', '1 reversed' */
  outcome_label: string;
  /** Patient name if single-patient remittance */
  patient_name?: string | null;
  /** Total patient responsibility in cents */
  patient_responsibility_cents?: number;
  /** Payer identifier */
  payer_id?: string | null;
  /** Payer name */
  payer_name?: string | null;
  /** Payment date (ISO 8601) */
  payment_date?: string | null;
  /** Payment method: ACH or Check */
  payment_method?: string | null;
  /** Remittance ID */
  remittance_id: string;
  /** Number of reversed claims */
  reversal_count?: number;
  /** Source system */
  source_system?: string | null;
  /** Total payment in cents */
  total_paid_cents?: number | null;
  /** Check or EFT trace number */
  trace_number: string;
};
export type SegmentCount3 = {
  /** Number of items in this segment */
  count: number;
  /** Segment key */
  key: string;
  /** Display label */
  label: string;
  /** Color hint: error, warning, success, or null */
  severity?: string | null;
};
export type RemittancesV2Response = {
  /** Current page */
  page: number;
  /** Items per page */
  per_page: number;
  /** Remittance rows */
  remittances: RemittanceV2Item[];
  /** Outcome-grouped segment counts */
  segments: SegmentCount3[];
  /** Human-readable summary line */
  summary: string;
  /** Total matching remittances */
  total: number;
  /** Total pages */
  total_pages: number;
};
export type BillingTaskCategory =
  | "manual_review"
  | "era_attention"
  | "withheld_posting";
export type BillingTaskStatus =
  | "open"
  | "in_progress"
  | "resolved"
  | "dismissed";
export type BillingTaskSubjectType = "claim" | "remittance_claim";
export type BillingTaskItem = {
  billing_task_id: string;
  category: BillingTaskCategory;
  category_label: string;
  created_at?: string | null;
  created_by_principal_id: string;
  created_by_principal_kind: "user" | "staff" | "agent" | "system" | "patient";
  paid_resolution_id?: string | null;
  paid_resolution_issue_key?: string | null;
  reason: string;
  resolution_note?: string | null;
  resolved_at?: string | null;
  resolved_by_principal_id?: string | null;
  resolved_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  status: BillingTaskStatus;
  status_label: string;
  subject_id: string;
  subject_type: BillingTaskSubjectType;
  updated_at?: string | null;
};
export type SegmentCount4 = {
  /** Number of items in this segment */
  count: number;
  /** Segment key */
  key: string;
  /** Display label */
  label: string;
  /** Color hint: error, warning, success, or null */
  severity?: string | null;
};
export type BillingTaskListResponse = {
  items?: BillingTaskItem[];
  /** Current page (1-based) */
  page: number;
  /** Items per page */
  per_page: number;
  segments?: SegmentCount4[];
  /** Total items matching filters */
  total: number;
  /** Total pages */
  total_pages: number;
};
export type BillingTaskStatus2 =
  | "open"
  | "in_progress"
  | "resolved"
  | "dismissed";
export type BillingTaskCategory2 =
  | "manual_review"
  | "era_attention"
  | "withheld_posting";
export type BillingTaskSubjectType2 = "claim" | "remittance_claim";
export type BillingTaskCategory3 =
  | "manual_review"
  | "era_attention"
  | "withheld_posting";
export type BillingTaskStatus3 =
  | "open"
  | "in_progress"
  | "resolved"
  | "dismissed";
export type BillingTaskSubjectType3 = "claim" | "remittance_claim";
export type BillingTaskItem2 = {
  billing_task_id: string;
  category: BillingTaskCategory3;
  category_label: string;
  created_at?: string | null;
  created_by_principal_id: string;
  created_by_principal_kind: "user" | "staff" | "agent" | "system" | "patient";
  paid_resolution_id?: string | null;
  paid_resolution_issue_key?: string | null;
  reason: string;
  resolution_note?: string | null;
  resolved_at?: string | null;
  resolved_by_principal_id?: string | null;
  resolved_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  status: BillingTaskStatus3;
  status_label: string;
  subject_id: string;
  subject_type: BillingTaskSubjectType3;
  updated_at?: string | null;
};
export type BillingTaskResponse = {
  task: BillingTaskItem2;
};
export type BillingTaskCategory4 =
  | "manual_review"
  | "era_attention"
  | "withheld_posting";
export type BillingTaskSubjectType4 = "claim" | "remittance_claim";
export type CreateBillingTaskRequest = {
  /** Why the task exists */
  category: BillingTaskCategory4;
  /** What needs doing and why */
  reason: string;
  /** Id of the claim or remittance claim */
  subject_id: string;
  /** What kind of record the task is about */
  subject_type: BillingTaskSubjectType4;
};
export type BillingTaskStatus4 =
  | "open"
  | "in_progress"
  | "resolved"
  | "dismissed";
export type UpdateBillingTaskStatusRequest = {
  /** Note recorded on resolve/dismiss */
  resolution_note?: string | null;
  /** The new status */
  status: BillingTaskStatus4;
};
export type WorkItem = {
  /** Button text */
  action_label: string;
  /** Deep link path */
  action_link?: string | null;
  /** Relative timestamp */
  age?: string | null;
  /** Category label: DENIED CLAIM, CLAIM ERRORS, etc. */
  category: string;
  /** Context line: provider · payer */
  context?: string | null;
  /** Service date */
  date?: string | null;
  /** Human-readable explanation (denial code, top blocker) */
  explanation?: string | null;
  /** Work item ID (claim_id, statement_run_id, etc.) */
  id: string;
  /** Meta line: CPT · amounts · error counts */
  meta?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Patient display name */
  patient_name?: string | null;
  /** Priority group: now, soon, ready */
  priority: string;
  /** What to do about this item */
  recommended_action?: string | null;
  /** Segment key: denied, errors, ready, toSend */
  segment: string;
  /** Severity: error, warning, success */
  severity: string;
  /** Source entity ID */
  source_id: string;
  /** Source: claim, encounter, statement_run */
  source_type: string;
};
export type WorkGroup = {
  /** Number of items in this group */
  count?: number;
  /** Work items */
  items?: WorkItem[];
  /** Priority key: now, soon, ready */
  key: string;
  /** Group label */
  label: string;
  /** Group description */
  sublabel: string;
};
export type SegmentCount5 = {
  /** Number of items in this segment */
  count: number;
  /** Segment key */
  key: string;
  /** Display label */
  label: string;
  /** Color hint: error, warning, success, or null */
  severity?: string | null;
};
export type WorkQueueResponse = {
  /** Priority-grouped work items */
  groups: WorkGroup[];
  /** Segment counts for filter pills */
  segments: SegmentCount5[];
  /** Human-readable summary: '14 items need attention' */
  summary: string;
};
export type ChargeLinePreviewLine = {
  /** True if this line is already INVOICED or PAID — the modal should warn the user before re-billing. */
  already_invoiced?: boolean;
  /** Sum of payments allocated to this charge_line via payment_allocations. Useful for showing 'paid X of Y' on the receipt. Account-level / unallocated payments don't show here — see ChargeLinePreviewResponse.unallocated_credit_cents. */
  applied_payment_cents?: number;
  charge_line_id: string;
  /** CPT or HCPCS billing code, when known */
  cpt_code?: string | null;
  description?: string | null;
  /** Remaining amount the patient owes for this line, in cents. Already net of any payment_allocations targeting this line — so for a $200 charge with $200 allocated against it, this is 0. */
  patient_due_cents: number;
};
export type ChargeLinePreviewEncounter = {
  /** Sum of patient_due_cents across this encounter's lines */
  encounter_due_cents: number;
  /** Null for ad-hoc charges with no encounter linkage */
  encounter_id?: string | null;
  /** Display label, e.g. 'Follow-up' */
  encounter_type_label?: string | null;
  lines?: ChargeLinePreviewLine[];
  provider_name?: string | null;
  /** Canonical billing date as ISO 8601 (date) */
  service_date?: string | null;
};
export type PatientResponsibilityBreakdown2 = {
  coinsurance_cents?: number;
  copay_cents?: number;
  deductible_cents?: number;
  other_cents?: number;
};
export type ChargeLinePreviewResponse = {
  encounters?: ChargeLinePreviewEncounter[];
  /** Patient owning all the requested charge_lines (validated server-side; mixed patients return 400). */
  patient_id: string;
  /** Copay/coinsurance/deductible split for the previewed encounter set, when confirmed ERA responsibility exists. */
  patient_responsibility_breakdown?: PatientResponsibilityBreakdown2 | null;
  /** BE-synthesized default for the modal's 'reason' field. FE should pre-fill this; user can edit before sending. */
  suggested_reason: string;
  /** Authoritative amount to bill for the selected line set. Account-level credits can reduce this below the sum of per-line patient_due_cents; unrelated account charges do not inflate a subset preview. */
  total_due_cents: number;
  /** Difference between sum(per-line remaining) and the ledger total. Represents account-level credits (manual cash, write-offs, prepays) that lowered the ledger but didn't target any specific charge_line. The FE should render this as a separate 'Applied credits' line so the receipt totals reconcile to total_due_cents. */
  unallocated_credit_cents?: number;
};
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ChargeLinePreviewRequest = {
  /** Explicit list of charge_line_ids to preview. All must belong to the same patient. Use this for partial settlement / statement-run flows where the caller already has IDs. */
  charge_line_ids?: string[] | null;
  /** Resolve all charge_lines on this encounter. Ergonomic shorthand for the common case (ledger tab, settle modal). Mutually exclusive with charge_line_ids. */
  encounter_id?: string | null;
  /** Resolve this patient's invoiceable outstanding charge_lines. Use this for patient detail / toolbar entry points where the caller wants the backend to suggest the billable set. Mutually exclusive with charge_line_ids and encounter_id. */
  patient_id?: string | null;
};
export type CertificationFindingAnchorItem = {
  kind:
    | "claim"
    | "claim_field"
    | "claim_line"
    | "diagnosis"
    | "note_section"
    | "coverage";
  ref?: {
    [key: string]: any;
  };
  role: "target" | "evidence";
};
export type CertificationFindingEffectItem = {
  authority:
    | "legacy_annotation"
    | "readiness"
    | "submission_preflight"
    | "none";
  authority_code?: string | null;
  blocks_submission: boolean;
  finding_key: string;
  gate_version: string;
};
export type CertificationFindingItem = {
  anchors?: CertificationFindingAnchorItem[];
  anchors_schema_version?: number;
  certification_effect: CertificationFindingEffectItem;
  disposition_state?: string | null;
  disposition_status: "current" | "reconciliation_required";
  disposition_version?: number | null;
  evidence_refs?: {
    [key: string]: any;
  }[];
  finding_key: string;
  observation: string;
  policy_id: string;
  policy_title: string;
  provisional: boolean;
  remediation?: {
    [key: string]: any;
  } | null;
  resolved_kind?: string | null;
  severity: string;
  source_capability: "available" | "redacted" | "not_applicable";
  target_kind: string;
  target_ref?: {
    [key: string]: any;
  };
  why?: string | null;
};
export type CertificationCountSummary = {
  active_evaluations: number;
  blockers: number;
  findings: number;
  missing_dispositions: number;
  suggestions: number;
};
export type CertificationWarning = {
  code: string;
  count: number;
};
export type ClaimCertificationResponse = {
  blockers?: CertificationFindingItem[];
  certification_freshness: "current" | "stale" | "missing" | "unknown";
  certification_status: string;
  claim_id: string;
  counts: CertificationCountSummary;
  last_verdict_at?: string | null;
  not_eligible_reason?: ("void" | "superseded") | null;
  recheck_state: "idle" | "checking";
  suggestions?: CertificationFindingItem[];
  suppressions?: {
    [key: string]: any;
  }[];
  warnings?: CertificationWarning[];
};
export type CertificationDispositionItem = {
  resolved_kind?: string | null;
  state: string;
  times_reopened: number;
  update_source: string;
  updated_at?: string | null;
  version: number;
};
export type DispositionCommandResponse = {
  disposition: CertificationDispositionItem;
  finding_key: string;
};
export type CertificationDispositionItem2 = {
  resolved_kind?: string | null;
  state: string;
  times_reopened: number;
  update_source: string;
  updated_at?: string | null;
  version: number;
};
export type DispositionConflictResponse = {
  current: CertificationDispositionItem2;
  error_code: string;
  message: string;
  status?: number;
};
export type DispositionCommandRequest = {
  expected_version: number;
};
export const {
  useGetV2ProviderBillingV2ClaimCasesQuery,
  useGetV2ProviderBillingV2ClaimCasesByClaimIdQuery,
  usePostV2ProviderBillingV2ClaimCasesByClaimIdReviewMutation,
  useGetV2ProviderBillingV2ClaimWorkQuery,
  useGetV2ProviderBillingV2ClaimWorkSavedViewsQuery,
  usePostV2ProviderBillingV2ClaimWorkSavedViewsMutation,
  useDeleteV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdMutation,
  usePutV2ProviderBillingV2ClaimWorkSavedViewsBySavedViewIdMutation,
  useGetV2ProviderBillingV2ClaimsQuery,
  useGetV2ProviderBillingV2ClaimsByClaimIdPaidResolutionQuery,
  usePostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopenMutation,
  usePostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolveMutation,
  usePostV2ProviderBillingV2EncountersByEncounterIdWorkDispositionMutation,
  useGetV2ProviderBillingV2EncountersByEncounterIdWorkNotesQuery,
  usePostV2ProviderBillingV2EncountersByEncounterIdWorkNotesMutation,
  useDeleteV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdMutation,
  usePatchV2ProviderBillingV2EncountersByEncounterIdWorkNotesAndNoteIdMutation,
  useGetV2ProviderBillingV2OverviewQuery,
  useGetV2ProviderBillingV2PatientBillingQueueQuery,
  useGetV2ProviderBillingV2PatientBillingSentQuery,
  useGetV2ProviderBillingV2PatientsByPatientIdAccountHistoryQuery,
  usePostV2ProviderBillingV2PatientsByPatientIdChargeAssignmentsMutation,
  usePostV2ProviderBillingV2PatientsByPatientIdCreditAllocationsMutation,
  useGetV2ProviderBillingV2PatientsByPatientIdFinancialSummaryQuery,
  useGetV2ProviderBillingV2PatientsByPatientIdRefundablePaymentsQuery,
  usePostV2ProviderBillingV2PatientsByPatientIdRefundsMutation,
  useGetV2ProviderBillingV2PayerOptionsQuery,
  useGetV2ProviderBillingV2RemittancesQuery,
  useGetV2ProviderBillingV2TasksQuery,
  usePostV2ProviderBillingV2TasksMutation,
  usePatchV2ProviderBillingV2TasksByBillingTaskIdStatusMutation,
  useGetV2ProviderBillingV2WorkQuery,
  usePostV2ProviderChargeLinesPreviewMutation,
  useGetV2ProviderClaimsByClaimIdCertificationQuery,
  usePostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyDismissMutation,
  usePostV2ProviderClaimsByClaimIdCertificationFindingsAndFindingKeyReopenMutation,
  usePostV2ProviderClaimsByClaimIdCertificationRecheckMutation,
} = injectedRtkApi;
